import { Box } from "@mui/material";
import { History } from "@mui/icons-material";
import { useNavigate, useParams } from "react-router-dom";

import { PageLayout } from "../../layouts/PageLayout";
import { PageHeader } from "../../components/v3";
import { AddBulkWorkerPaymentForm } from "../../components/transaction";
import { WEEKLY_WORKER_PAYMENT_ROUTES } from "./constants";

export const AddBulkWorkerPayment = () => {
  const { sessionId } = useParams();
  const navigate = useNavigate();

  return (
    <PageLayout>
      <Box sx={{ position: "relative", zIndex: 1 }}>
        <PageHeader
          title={sessionId ? "Edit Weekly Worker Payment" : "Weekly Worker Payment"}
          subtitle={sessionId ? `Session: ${sessionId}` : ""}
          buttons={[
            {
              buttonText: "History",
              buttonIcon: History,
              onClick: () => navigate(WEEKLY_WORKER_PAYMENT_ROUTES.history),
            },
          ]}
        />
      </Box>

      <Box sx={{ mt: -9, zIndex: 2, position: "relative" }}>
        <AddBulkWorkerPaymentForm sessionId={sessionId} />
      </Box>
    </PageLayout>
  );
};
